import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SavedPrescriptions {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  savedPrescriptionData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: SavedPrescriptions = {
  isLoading: false,
  error: false,
  message: null,
  savedPrescriptionData: [],
  Items: [],
  Pagination: [],
};

const SavedPrescriptionsSlice = createSlice({
  name: "savedprescriptions",
  initialState,
  reducers: {
    loadingSavedPrescriptions: (
      state: SavedPrescriptions,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setSavedPrescriptions: (
      state: any,
      action: PayloadAction<SavedPrescriptions>
    ) => {
      return action.payload;
    },
    clearData: (state: SavedPrescriptions, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingSavedPrescriptions, setSavedPrescriptions, clearData } =
  SavedPrescriptionsSlice.actions;

export default SavedPrescriptionsSlice.reducer;
